import { withLeaflet } from 'react-leaflet'
import AntPath from './AntPath.jsx'

export default withLeaflet(AntPath)
